module.exports = __webpack_public_path__ + "static/img/geren_LOGO.2399eab.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/geren_LOGO.png
// module id = mV5+
// module chunks = 52